export default function onEmailEntered(state, payload) {
  return Object.assign({}, state, {
    email: payload.email
  });
}
